import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';

import { AuthService } from '../../core/auth.service';
import { Lecture } from '../shared/lecture';
import { LectureUserService } from '../shared/lecture-user.service';

@Component({
  selector: 'app-lecture-nav-item',
  templateUrl: './lecture-nav-item.component.html',
  styleUrls: ['./lecture-nav-item.component.scss']
})
export class LectureNavItemComponent {
  @Input() lecture: Lecture;
  enrollmentObservable: Observable<any>;

  constructor(private router: Router, private service: LectureUserService, private auth: AuthService) { }

  isApproved(lecture: Lecture) {
    this.router.navigate(['/lectures', lecture.$key]);
    this.enrollmentObservable = this.service.readEnrollment(this.lecture);
  }

  get isAuthenticated() {
    return this.auth.isAuthenticated;
  }
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/lectures/lecture-nav-item/lecture-nav-item.component.ts